import PropTypes from 'prop-types';
import React from 'react';
import path from 'path';
import dealerApi from 'api/dealer';
import session from 'services/sessionService';

/**
 * Wraps tools pages into a wrapper, and a sequence of Views (with no url routing).
 * @param  {Component}    Page  Main wrapper component for styles and state on every view.
 * @param  {Components} views Each individual view component. Receive a nextView function prop and a moreViews bool prop.
 * @return {Component}          New wrapped component.
 */
export default function toolFlow(Page, ...views) {
  return class extends React.Component {
    static displayName = 'toolFlow(' + Page.displayName + ')';

    static propTypes = {
      page: PropTypes.number,
    };

    static defaultProps = {
      page: 0,
    };

    nextView = () => {
      if (this.props.page < views.length - 1) {
        location.hash = path.join(location.hash, '..', parseInt(this.props.page) + 1 + '');
      }
    };

    setPage = (page) => {
      location.hash = path.join(location.hash, '..', page + '');
    };

    render() {
      return <Page {...this.props}
                   setPage={this.setPage}
                   View={injectView(views[this.props.page], this.nextView, this.props.page < views.length - 1)}/>;
    }
  };
}


function injectView(View, nextView, moreViews) {
  return class extends React.Component {
    static displayName = 'injectView(' + View.displayName + ')';

    render() {
      return <View {...this.props} nextView={nextView}
                   moreViews={moreViews}/>;
    }
  };
}
